<template>
    <div class="page questions-page">
        <v-container class="py-0 py-lg-6" :class="{'px-0': phoneOnly}">
            <transition name="fade-transition">
                <questions v-if="current_directory || categories.data" :path="path" :categories="categories" :questions="questions" :current_directory="current_directory" :filter-mode="filterMode" @filter="filterQuestions" />
            </transition>
        </v-container>
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import Questions from './Questions'

export default {
    name: "QuestionsBank",
    components: {
        Questions
    },
    props: {
        id: {},
    },
    data(){
        return {
            loading: false,
            categories: {
                data: null
            },
            questions: {
                data: null,
                links: null,
                meta: null,
            },
            current_directory: null,
            originalQuestions: {
                data: null,
                links: null,
                meta: null,
            },
            filterMode: false,
            pageNumber: null,
            questionNumber: null,
        }
    },
    computed: {
        ...GlobalComputed,
        path(){
            // const query = this.$route.query.path;
            return `/bank-questions/directories${this.id ? '/' + this.id : ''}`;
        },
    },
    methods: {
        ...GlobalMethods,
        loadData(){
            if (!this.loading){
                this.loading = true;
                let params = {};
                if (this.pageNumber){
                    params.page_number = this.pageNumber;
                }
                if (this.questionNumber){
                    params.question_number = this.questionNumber;
                }
                window.axios.get(this.path, {params}).then(response=>{
                    // Reduce an addtional req on reset filter by using originalQues for better performance
                    if (!this.filterMode){
                        this.originalQuestions = response.data.questions;
                    }
                    let categories = response.data.categories;
                    this.categories = categories;
                    this.questions = response.data.questions;
                    this.current_directory = response.data.current_directory;
                    this.loading = false;
                }).catch((e)=>{
                    this.loading = false;
                    if (e && e.response && e.response.status === 404){
                        // this.$router.push('/not-found');
                        this.showMsg('لم يتم العثور على نتيجة');
                    }else{
                        this.showMsg('حدثت مشكلة أثناء تحميل البيانات');
                    }
                });
            }
        },
        filterQuestions(pageNumber, questionNumber){
            this.pageNumber = pageNumber;
            this.questionNumber = questionNumber;
            if (pageNumber || questionNumber){
                this.filterMode = true;
                this.loadData();
            } else {
                this.filterMode = false;
                this.questions = this.originalQuestions;
            }
        },

    },
    watch: {
        path(path){
            // Reset filter on path change
            if (this.pageNumber || this.questionNumber){
                this.pageNumber = null;
                this.questionNumber = null;
                this.filterMode = false;
            }
            this.loadData();
        },
        loading(loading){
            this.setLinearLoading(loading);
        }
    },
    created(){
        
    },
    mounted(){
        this.loadData();
    }
};
</script>
<style lang="scss" scoped>
.stats{
    margin: -8px;
    .col-lg-3, .col-lg-4{
        padding: 8px!important;
    }
}
</style>
